import '../../../../../Styles/Toyota.scss'

import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import LoadingGif from '../../../../../static/images/loading.gif';
import AppVars from '../../../../../AppVars.js';
import Logger from '../../../../../Logger.js';
import axios from 'axios';

import Error from '../../../../../static/images/TO/error.svg'
import Check from '../../../../../static/images/TO/checked.svg'
import Circle from '../../../../../static/images/TO/circle.svg'

let appVars = AppVars.getInstance()
let logger = Logger.getInstance();

class CreateUserFormView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
        };
    }
    
    render(){
        return(
            <div>
            <div className = "justify-content-center register-line-box">
            <Col>
            <div role = "banner">
            <Row className = "">
            <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../../static/images/Toyota-Logo.svg').default} /></a>
            </Row>
            </div>
            <div id = "localRegisterFormAlert"
            data-testid = "localRegisterFormError" 
            className = {`${this.props.isResponseValid === false ? "error-modal" : "none"}`} 
            role = "alert"
            aria-hidden = {`${this.props.isResponseValid === false ? "false" : "true"}`}>
            <div className = "error-modal-text">
                The service is down. Please try again shortly.
            </div>
            <span onClick={this.props.hideModal} className = "modal-close">&times;</span>
            </div>
            <div role = "main">
            <Row className = "justify-content-center location">
                <div>Registration</div>
            </Row>
            <Row className = "title__TO left">Create Account</Row>
            <Row>
            </Row>
            <Row className = "justify-content-center message__TO left">
                It looks like you don't have a Toyota account. Complete registration below to create one.
            </Row>

            <Form id = "localRegisterForm" noValidate validated = {this.props.isFirstNameValid && this.props.isLastNameValid && this.props.isPhoneValid && this.props.isPasswordValid} onSubmit = {this.props.handleFormSubmit}>
            {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
            <Form.Group id = "showEmailGroupLocal" className = "relative">
            <Form.Label className = "absolute inline-label">
            Email
            </Form.Label>
                <Form.Control
                    required
                    readOnly
                    id = "showUsername__TO"
                    data-testid = "showUsername"
                    aria-label = "Username"
                    as = "input"
                    type = "text"
                    name = "username"
                    placeholder = {this.props.email}
                    bsPrefix = "readOnly form-control"
                />
            </Form.Group>
            <Form.Group id = "createFirstNameGroupLocal" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatFirstName === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.firstNameFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "label-red__TO" : ""}
                `}>
                    First Name<span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "createFirstName__TO"
                    data-testid = "createFirstName"
                    aria-label = "First Name"
                    as = "input"
                    type = "text"
                    name = "firstname"
                    placeholder = ""
                    value = {this.props.firstName}
                    onChange = {this.props.handleFirstNameChange}
                    onFocus = {this.props.setFocusFirstName}
                    onBlur = {this.props.onBlurFirstName}
                    bsPrefix = {`${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createFirstNameAlert" 
                data-testid = "createFirstNameError" 
                className = {`logon-item-error__TO ${this.props.isFirstNameValid === false && this.props.firstNameFocus === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isFirstNameValid === false ? "false" : "true"}`}
            >
                Your first name must be between 1 and 14 characters. It can include spaces, apostrophes, and hyphens.
            </div>
            </Form.Group>
            <Form.Group id = "createLastNameGroupLocal" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatLastName === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.lastNameFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "label-red__TO" : ""}
                `}>
                    Last Name<span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "createLastName__TO"
                    data-testid = "createLastName"
                    aria-label = "Last Name"
                    as = "input"
                    type = "text"
                    name = "lastname"
                    placeholder = ""
                    value = {this.props.lastName}
                    onChange = {this.props.handleLastNameChange}
                    onFocus = {this.props.setFocusLastName}
                    onBlur = {this.props.onBlurLastName}
                    bsPrefix = {`${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createLastNameAlert" 
                data-testid = "createLastNameError" 
                className = {`logon-item-error__TO ${this.props.isLastNameValid === false && this.props.lastNameFocus === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isLastNameValid === false ? "false" : "true"}`}
            >
                Your last name must be between 1 and 29 characters. It can include spaces, apostrophes, and hyphens.
            </div>
            </Form.Group>
            <Form.Group id = "createPhoneGroupLocal" className = "relative">
            <Form.Label className = {`${this.props.floatPhone === true ? "absolute floating-label" : "absolute inline-label" }
                                    ${this.props.phoneFocus === true ? "label-black__TO" : "" }
                                    ${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "label-red__TO" : ""}
            `}>
                Mobile Number<span id="redStar">*</span></Form.Label>
            <Form.Control
                required
                id = "createPhone__TO"
                data-testid = "createPhone"
                aria-label = "Phone"
                as = "input"
                type = "phone"
                name = "phone"
                placeholder = ""
                value = {this.props.phone}
                onChange = {this.props.handlePhoneChange}
                onFocus = {this.props.setFocusPhone}
                onBlur = {this.props.onBlurPhone}
                bsPrefix = {`${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "highlight-error__TO form-control" : ""}`}
            />
            <div 
                id = "createPhoneAlert" 
                data-testid = "createPhoneError" 
                className = {`logon-item-error__TO ${this.props.isPhoneValid === false && this.props.phoneFocus === false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${this.props.isPhoneValid === false ? "false" : "true"}`}
            >
                Please enter a valid phone number.
            </div>
            <div 
                id = "createPhoneAlert" 
                data-testid = "createPhoneError" 
                className = {`logon-item-error__TO ${this.props.isPhoneAvailable === false && this.props.phoneFocus === false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${this.props.isPhoneAvailable === false ? "false" : "true"}`}
            >
                This mobile number is already in use.
            </div>
            </Form.Group>
            <Form.Group id = "createPasswordGroupLocal" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatPassword === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${this.props.passwordFocus === true ? "label-black__TO" : "" }
                                        ${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "label-red__TO" : ""}`}>
                Password
                <span id="redStar">*</span></Form.Label>
                <div className="absolute show-password">
                    <img onClick={this.props.showHidePassword} src={this.props.showPassword ? require('../../../../../static/images/TO/password-hide.svg').default : require('../../../../../static/images/TO/password-show.svg').default} alt="showHide"></img>
                    <span className='show-hide'>{this.props.showPassword ? 'Hide' : 'Show'}</span>
                </div>
                <Form.Control
                    required
                    id = "createPassword__TO"
                    data-testid = "createPassword"
                    aria-label = "Password"
                    as = "input"
                    type = {`${this.props.showPassword === false ? "password" : "text"}`}
                    name = "password"
                    placeholder = ""
                    value = {this.props.password}
                    onChange = {this.props.handlePasswordChange}
                    onFocus = {this.props.setFocusPassword}
                    onBlur = {this.props.onBlurPassword}
                    bsPrefix = {`${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createPasswordAlert" 
                data-testid = "createPasswordError" 
                className = {`${this.props.isPasswordValid === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isPasswordValid === false ? "false" : "true"}`}
            >
                <table className = "password-req-table">
                    <tbody>
                    <tr>
                        <td className = "password-error-symbol">
                            <img src = {`${this.props.isPasswordLength === null ? Circle : "" }`} ></img>
                            <img src = {`${this.props.isPasswordLength === false ? Error : ""}`} ></img>
                            <img src = {`${this.props.isPasswordLength === true ? Check : ""}`} ></img></td>
                        <td className = "password-error">8 character minimum, 16 character maximum</td>
                    </tr>
                    <tr>
                        <td className = "password-error-symbol">
                            <img src = {`${this.props.isPasswordCase === null ? Circle : "" }`} ></img>
                            <img src = {`${this.props.isPasswordCase === false ? Error : ""}`} ></img>
                            <img src = {`${this.props.isPasswordCase === true ? Check : ""}`} ></img>
                            </td>
                        <td className = "password-error">Use uppercase and lowercase letters, password is case sensitive</td>
                    </tr>
                    <tr>
                        <td className = "password-error-symbol">
                        <img src = {`${this.props.isPasswordNumber === null ? Circle : "" }`} ></img>
                            <img src = {`${this.props.isPasswordNumber === false ? Error : ""}`} ></img>
                            <img src = {`${this.props.isPasswordNumber === true ? Check : ""}`} ></img>
                        </td>
                        <td className = "password-error">Use a number (0-9)</td>
                    </tr>
                    <tr>
                        <td className = "password-error-symbol">
                        <img src = {`${this.props.isPasswordSpecial === null ? Circle : "" }`} ></img>
                            <img src = {`${this.props.isPasswordSpecial === false ? Error : ""}`} ></img>
                            <img src = {`${this.props.isPasswordSpecial === true ? Check : ""}`} ></img>
                        </td>
                        <td className = "password-error">Use a special character / symbol</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            </Form.Group>
            <div className = "required required-right-grid">
                <span id="redStar">*</span>Required
            </div>
            <div className = "local-register-button">
            <Button id = "registerLocalButton" data-testid = "registerLocalButton" bsPrefix = {`${(this.props.isFirstNameValid && this.props.isLastNameValid && this.props.isPhoneValid && this.props.isPasswordValid) !== true ? "button-disabled__TO" : "button__TO "}`} type = "submit" >Create Account</Button>
            </div>
            <Image data-testid = "loadingGIF" className = {`working ${this.props.loading ? "" : "none"}`} id = "loadingGIF" src={LoadingGif} aria-hidden = "true"/>
        </Form>
        </div>
        </Col>
        </div>
        </div>

          
    );

    }

}




export default CreateUserFormView;